import VehicleMaintenanceCard from "../../../maintenance/components/VehicleMaintenanceCard";
import VehicleMaintenanceHistory from "../../../maintenance/components/VehicleMaintenanceHistory";
import { Vehicle } from "../../@types";

interface MaintenanceHistoryTabProps {
  vehicleId: string;
  vehicle?: Vehicle;
}

const MaintenanceHistoryTab: React.FC<MaintenanceHistoryTabProps> = ({
  vehicleId,
  vehicle,
}) => {
  return (
    <div className="space-y-6">
      {vehicle && <VehicleMaintenanceCard vehicle={vehicle} />}
      <VehicleMaintenanceHistory vehicleId={vehicleId} />
    </div>
  );
};

export default MaintenanceHistoryTab;
